import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import OscarSettingsHtml from './oscar.settings.html';

export function OscarStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'OscarSettingsCtrl',
    name       : 'app.oscar-settings',
    templateUrl: OscarSettingsHtml,
    url        : '/oscar_settings',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      session     : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings    : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      user        : ( sessionObjAPI : SessionService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/user', sessionObjAPI.user().id)
    }
  });
}